export enum CoupaPurchaseStatus {
    SUPPLIER_WINDOW_HOLD = 'supplier_window_hold',
    CLOSED = 'closed',
    CANCELLED = 'cancelled',
    SOFT_CLOSED = 'soft_closed',
    ISSUED = 'issued',
}
